export default class Statistik {
    private static _instance: Statistik;

    public static getInstance() {
        return this._instance || (this._instance = new this());
    }

    private lastPush: number = 0;
    private lastPushName: string = "";

    public pushStat(name: string, value: string): boolean {
        try {
            if (this.lastPushName === name && this.lastPush > (Date.now() - 10000) && name !== 'bericht-download') return false; // 10 Sekunden keine Dopplung
            if (this.lastPushName !== name && this.lastPush > (Date.now() - 500)) return false; // 0,5 Sekunden keine unterschiedlichen

            if ((name ?? '') === '' || (value ?? '') === '') return false; //leere Strings nicht zulassen

            let payload = {
                name: name,
                value: value ?? '1'
            };

            $.ajax({
                url: "/api/statistik-push.php",
                type: "POST",
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(payload)
            });
        } catch (err) {
            return false;
        }

        this.lastPush = Date.now();
        this.lastPushName = name;
    }
}
